import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2, ArrowLeft } from "lucide-react";

export default function ConfiguracionComisiones() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ nombre: "", tipo: "comision", metodo_calculo: "porcentaje", valor: "" });

  const load = async () => { const { data } = await api.get("/catalogo-comisiones"); setRows(data || []); };
  useEffect(() => { load(); }, []);

  const agregar = async () => {
    if (!form.nombre || !form.valor) return toast.error("Nombre y valor requeridos");
    try { await api.post("/catalogo-comisiones", { nombre: form.nombre, tipo: form.tipo, metodo_calculo: form.metodo_calculo, valor: Number(form.valor) || 0, activo: true }); toast.success("Concepto agregado"); setForm({ nombre: "", tipo: "comision", metodo_calculo: "porcentaje", valor: "" }); load(); }
    catch (err) { toast.error(`Error: ${err?.response?.data?.detail || err.message}`); }
  };
  const toggle = async (id) => { try { await api.patch(`/catalogo-comisiones/${id}/activo`); load(); } catch (err) { toast.error(`Error: ${err?.response?.data?.detail || err.message}`); } };
  const eliminar = async (id) => { try { await api.delete(`/catalogo-comisiones/${id}`); setRows((p) => p.filter((r) => r.id !== id)); toast.success("Eliminado"); } catch (err) { toast.error(`Error: ${err?.response?.data?.detail || err.message}`); } };

  return (
    <div className="max-w-4xl mx-auto space-y-6" data-testid="config-comisiones-page">
      <Button variant="ghost" size="sm" onClick={() => navigate("/configuracion")}><ArrowLeft className="h-4 w-4 mr-2" /> Configuración</Button>
      <div><h1 className="text-3xl font-bold tracking-tight">Comisiones</h1><p className="text-muted-foreground mt-2">Catálogo de conceptos de comisión.</p></div>
      <Card><CardContent className="pt-6 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
          <div className="space-y-2 md:col-span-2"><Label>Nombre</Label><Input value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} data-testid="cc-nombre" /></div>
          <div className="space-y-2"><Label>Método</Label>
            <Select value={form.metodo_calculo} onValueChange={(v) => setForm({ ...form, metodo_calculo: v })}>
              <SelectTrigger data-testid="cc-metodo"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="porcentaje">Porcentaje</SelectItem><SelectItem value="monto_fijo">Monto fijo</SelectItem></SelectContent>
            </Select>
          </div>
          <div className="space-y-2"><Label>Valor</Label><Input type="number" value={form.valor} onChange={(e) => setForm({ ...form, valor: e.target.value })} data-testid="cc-valor" /></div>
          <Button onClick={agregar} data-testid="cc-add"><Plus className="h-4 w-4 mr-2" /> Agregar</Button>
        </div>
        <div className="border rounded-md">
          <Table>
            <TableHeader><TableRow><TableHead>Nombre</TableHead><TableHead>Método</TableHead><TableHead>Valor</TableHead><TableHead>Estado</TableHead><TableHead className="w-12"></TableHead></TableRow></TableHeader>
            <TableBody>
              {rows.length === 0 ? <TableRow><TableCell colSpan={5} className="text-center h-20 text-muted-foreground">Sin conceptos.</TableCell></TableRow>
                : rows.map((c) => (
                  <TableRow key={c.id}>
                    <TableCell className="font-medium">{c.nombre}</TableCell>
                    <TableCell>{c.metodo_calculo === "porcentaje" ? "Porcentaje" : "Monto fijo"}</TableCell>
                    <TableCell>{c.metodo_calculo === "porcentaje" ? `${c.valor}%` : `$${Number(c.valor).toFixed(2)}`}</TableCell>
                    <TableCell><Badge className={c.activo ? "bg-emerald-500 cursor-pointer" : "bg-slate-400 cursor-pointer"} onClick={() => toggle(c.id)}>{c.activo ? "Activo" : "Inactivo"}</Badge></TableCell>
                    <TableCell><Button variant="ghost" size="icon" className="text-destructive" onClick={() => eliminar(c.id)}><Trash2 className="h-4 w-4" /></Button></TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      </CardContent></Card>
    </div>
  );
}
